import Annotation from 'components/Annotation'
import { AnnotationTextMarker as TM } from 'components/Annotation/AnnotationTextMarker'
import { CircleAnnotation } from 'components/Annotation/CircleAnnotation'
import { CircleAnnotation2 } from 'components/Annotation/CircleAnnotation2'

const isMobile = window.innerWidth < 712

export const basel_data: CityData = {
  name: 'Basel',
  bfsid: '2701',
  sat_images: [
    {
      label: 'Tiefer Status - Klybeck',
      image: isMobile
        ? require('../../../Content/Maps/maps_2701_sat_poor_mob.jpg')
        : require('../../../Content/Maps/maps_2701_sat_poor.jpg'),
    },
    {
      label: 'Hoher Status - Bruderholz',
      image: isMobile
        ? require('../../../Content/Maps/maps_2701_sat_rich_mob.jpg')
        : require('../../../Content/Maps/maps_2701_sat_rich.jpg'),
    },
  ],
  elements: [
    {
      id: 'all',
      text: (
        <>
          <p>
            In Basel leben Menschen aus verschiedenen sozialen Schichten
            mehrheitlich in räumlich getrennten Wohngebieten. Einzig im Westen,
            im Quartier <TM prio={4}>Iselin</TM>, zeigt sich eine Durchmischung.
            Basel weist eine ähnliche Struktur auf wie Bern und Zürich.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 50 : 80}
              angle={isMobile ? 274 : 270}
            >
              Iselin
            </CircleAnnotation>
          ),
          position: { x: 24, y: 35 },
          position_mobile: { x: 20, y: 35 },
        },
        {
          content: <Annotation priority={3}>Klybeck/Kleinhüningen</Annotation>,
          position: { x: 50, y: 12 },
          position_mobile: { x: 55, y: 15 },
        },
        {
          content: <Annotation priority={3}>Gundeldingen</Annotation>,
          position: { x: 52, y: 61 },
          position_mobile: { x: 60, y: 60 },
        },
        {
          content: <Annotation priority={3}>St. Johann</Annotation>,
          position: { x: 27, y: 22 },
          // position_mobile: { x: 20, y: 20 },
        },
        {
          content: <Annotation priority={3}>Rosental</Annotation>,
          position: { x: 55, y: 31 },
          position_mobile: { x: 60, y: 33 },
        },
        {
          content: <Annotation priority={3}>Bruderholz</Annotation>,
          position: { x: 52, y: 75 },
          position_mobile: { x: 55, y: 71 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_2701_all_mob.jpg')
        : require('../../../Content/Maps/maps_2701_all.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_2701_all_mob_dm.jpg')
        : require('../../../Content/Maps/maps_2701_all_dm.jpg'),
    },
    {
      id: 'rich',
      text: (
        <>
          <p>
            Die Innenstadt ist mehr oder weniger vollständig von Privilegierten
            bewohnt. Das gilt auch für die bevorzugten Lagen am Rhein und weite
            Teile im Südwesten der Stadt.
          </p>
          <p>
            Auffällig ist das wenig dicht besiedelte Villenviertel{' '}
            <TM prio={2}>Bruderholz</TM> im südlichen Zipfel. Die Gegend war
            1910 als gehobenes Wohnviertel mit viel Grün geplant worden – und
            das ist sie bis heute geblieben.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 50 : 90}
              angle={isMobile ? 210 : 130}
            >
              Bruderholz
            </CircleAnnotation>
          ),
          position: { x: 49, y: 73 },
          position_mobile: { x: 50, y: 70 },
        },

        {
          content: <Annotation priority={3}>Iselin</Annotation>,
          position: { x: 17, y: 37 },
          position_mobile: { x: 5, y: 35 },
        },
        {
          content: <Annotation priority={3}>Klybeck/Kleinhüningen</Annotation>,
          position: { x: 50, y: 12 },
          position_mobile: { x: 55, y: 15 },
        },
        {
          content: <Annotation priority={3}>Gundeldingen</Annotation>,
          position: { x: 52, y: 61},
          position_mobile: { x: 60, y: 60 },
        },
        {
          content: <Annotation priority={3}>St. Johann</Annotation>,
          position: { x: 27, y: 18 },
          position_mobile: { x: 20, y: 24 },
        },
        {
          content: <Annotation priority={3}>Rosental</Annotation>,
          position: { x: 55, y: 31 },
          position_mobile: { x: 60, y: 33 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_2701_rich_mob.jpg')
        : require('../../../Content/Maps/maps_2701_rich.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_2701_rich_mob_dm.jpg')
        : require('../../../Content/Maps/maps_2701_rich_dm.jpg'),
    },
    {
      id: 'poor',
      text: (
        <>
          <p>
            In der Tendenz bekommt die Stadt gegen Norden ein ärmeres Gesicht –
            das zeigt sich beim ehemaligen Arbeiterquartier St. Johann sowie den
            Quartieren <TM prio={3}>Klybeck</TM> und{' '}
            <TM prio={3}>Kleinhüningen.</TM>
          </p>
          <p>
            Besonders auffällig sind die Konzentrationen rund um die grossen
            Infrastrukturbauten – also bei den Bahnhöfen sowie beim Schiffs- und
            beim Flughafen. Hier ist die Lebensqualität schlechter, und die
            Wohnungen sind günstiger.
          </p>
        </>
      ),
      annotations: [
        {
          content: <Annotation priority={3}>Bruderholz</Annotation>,
          position: { x: 52, y: 75 },
          position_mobile: { x: 55, y: 71 },
        },

        {
          content: <Annotation priority={3}>Iselin</Annotation>,
          position: { x: 17, y: 37 },
          position_mobile: { x: 5, y: 35 },
        },

        {
          content: <Annotation priority={3}>Gundeldingen</Annotation>,
          position: { x: 52, y: 61},
          position_mobile: { x: 60, y: 60 },
        },
        {
          content: <Annotation priority={3}>St. Johann</Annotation>,
          position: { x: 27, y: 18 },
          position_mobile: { x: 20, y: 24 },
        },
        {
          content: <Annotation priority={3}>Rosental</Annotation>,
          position: { x: 55, y: 31 },
          position_mobile: { x: 60, y: 33 },
        },

        {
          content: (
            <Annotation
              exactLocation
              align='middle'
              priority={2}
              offset={isMobile ? 50 : 90}
            >
              Bahnhof
            </Annotation>
          ),
          position: { x: 43, y: 44 },
          position_mobile: { x: 46, y: 43 },
        },
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 50 : 70}
              angle={isMobile ? 225 : 350}
            >
              Klybeck/
            </CircleAnnotation>
          ),
          position: { x: 47, y: 13 },
          position_mobile: { x: 55, y: 15 },
        },
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 50 : 70}
              angle={isMobile ? 205 : 368}
            >
              Kleinhüningen
            </CircleAnnotation>
          ),
          position: { x: 47, y: 13 },
          position_mobile: { x: 55, y: 15 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_2701_poor_mob.jpg')
        : require('../../../Content/Maps/maps_2701_poor.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_2701_poor_mob_dm.jpg')
        : require('../../../Content/Maps/maps_2701_poor_dm.jpg'),
    },
  ],
}
